import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    LineUserId: '',
  },

  actions: {
    // updateMessage(context, payload) {
    //   const timestamp = Math.floor(new Date() / 1000)
    //   const content = payload
    //   content.timestamp = timestamp

    //   context.commit('ALERTMESSAGE', content)

    //   setTimeout(() => {
    //     context.commit('REMOVEALERTWITHTIMIMG', content.timestamp)
    //   }, 1500)
    // },

    SaveLineId(context, status) {
      context.commit('SAVELINEID', status)
    },
  },
  mutations: {
    SAVELINEID(state, status) {
      state.LineUserId = status
    },
  },

  modules: {},

  getters: {
    LineUserId: (state) => state.LineUserId,
  },
})
